import React, { FC, useEffect, useState } from 'react';

import { each } from 'lodash';
import { useSelector } from 'react-redux';

import { selectFindingsOverview } from 'containers/Findings/FindingsOverview/selectors';

import { AlertCount } from './AlertCount';

interface SeverityCount {
  critical: number;
  high: number;
  medium: number;
  low: number;
}

export const AlertCountForAllCategories: FC = () => {
  const { aggregateAlertCategories } = useSelector(selectFindingsOverview);
  const [severities, setSeverities] = useState<SeverityCount>(
    {} as SeverityCount,
  );

  useEffect(() => {
    const items: SeverityCount = { critical: 0, high: 0, medium: 0, low: 0 };
    each(aggregateAlertCategories.data, aggregateCategory =>
      each(aggregateCategory, s => {
        items.critical += s?.severity?.CRITICAL ?? 0;
        items.high += s?.severity?.HIGH ?? 0;
        items.medium += s?.severity?.MEDIUM ?? 0;
        items.low += s?.severity?.LOW ?? 0;
      }),
    );

    setSeverities(items);
  }, [aggregateAlertCategories.data]);

  return <AlertCount {...severities} />;
};
